import { ShieldCheck, Eye, UserCog } from 'lucide-react';
import { usePortalAccess, type PortalKey } from '@/shared/hooks/usePortalAccess';

/** Header banner: "Super admin view" (admin), "Staff view · read-only" / "Staff access" (internal staff). */
export function SuperAdminBadge({ portal, className = '' }: { portal: PortalKey; className?: string }) {
  const { data } = usePortalAccess(portal);
  const base = `inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${className}`;
  if (data?.kind === 'admin') {
    return <span className={`${base} border-amber-400/60 bg-amber-400/15 text-amber-600 dark:text-amber-300`}><ShieldCheck className="h-3 w-3" /> Super admin view</span>;
  }
  if (data?.kind === 'staff' && data.level === 'view') {
    return <span className={`${base} border-border bg-muted text-muted-foreground`}><Eye className="h-3 w-3" /> Staff view · read-only</span>;
  }
  if (data?.kind === 'staff' && data.level === 'edit') {
    return <span className={`${base} border-primary/40 bg-primary/10 text-primary`}><UserCog className="h-3 w-3" /> Staff access</span>;
  }
  return null;
}
